const d = {
  color: {
    icon: {
      disabled: "#abb9c7ff"
    },
    placeholder: {
      disabled: "#abb9c7ff"
    },
    backdrop: {
      customRadio: {
        bg: "#c8d3deff"
      },
      selectedFilled: {
        bg: "#304ddbff",
        border: "#304ddbff"
      },
      disabled: {
        bg: "#f1f3f5ff"
      }
    }
  }
};
export {
  d as choice
};
